// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"styles_ellipsis__MvsCq","base":"styles_base__0hVdE","breakWord":"styles_breakWord__wnQuj"};